import MaintenancePage from "../MaintenancePage";
import resource from "../../resources/holidayResource";

export default function Holidays() {
    return <MaintenancePage resource={resource} />;
}
